import { useApiClient } from "@/src/hooks/useApiClient";
import { useQueryErrorToast } from "@/src/hooks/useQueryErrorToast";
import { useTranslations } from "@/src/i18n/i18n";

/**
 * Qui suit ce compte, et qui il suit.
 *
 * ⚠️ **Le paramètre est ici un id de compte**, à l'inverse de `useProfile` —
 * le service serveur s'appelle `getFavoriteProfiles(accountId)`. Les deux
 * identifiants cohabitent donc sur la même fiche : le profil donne son
 * `accountId`, qui sert de clé à cet appel. D'où le `enabled` : tant que la
 * fiche n'est pas chargée, on ne sait pas quoi demander.
 */
export function useFollows(accountId: number | undefined) {
  const $api = useApiClient();
  const t = useTranslations("accounts");

  const { data, error, isError, isLoading } = $api.useQuery(
    "get",
    "/api/v1/profile/favorite-profiles/{id}",
    { params: { path: { id: accountId ?? 0 } } },
    { enabled: accountId !== undefined },
  );

  useQueryErrorToast(isError, t("follows-error"), error);

  // ⚠️ Le contrat type la réponse **200** comme « charge utile *ou* erreur » :
  // le serveur documente ses codes d'échec sous le même statut. Sans ce
  // rétrécissement, `data.data` n'existe pas aux yeux de `tsc`.
  const payload = data && "data" in data ? data.data : undefined;

  return {
    followed: payload?.followed ?? [],
    followers: payload?.followers ?? [],
    isLoading: accountId !== undefined && isLoading,
    isError,
  };
}
